<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/userScoreHistory')">用户积分明细</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
        <div class="contain_header clr">
            <el-form
              :inline="true"
              class="m-search"
              size='small'
              :model="filters"
            >
            <el-form-item
              label="查询时间"
            >
                <el-form-item prop="startTime">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择开始日期"
                    v-model="filters.startTime"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
                <span style="display: inline-block;margin-right: 9px;">-</span>
                <el-form-item prop="endTime">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择结束日期"
                    v-model="filters.endTime"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>

            </el-form-item>
            <el-form-item label="关键字">
              <el-input style="width:300px" v-model="filters.userKeyword" clearable placeholder="请输入昵称或者手机号"></el-input>
            </el-form-item>

            <el-form-item label="代理类型">
              <el-select clearable v-model="filters.userType" placeholder="请选择">
                <el-option label="无" value="-1"></el-option>
                <el-option label="康减系列vip会员" value="-0.5"></el-option>
                <el-option label="康减系列高级会员" value="-0.4"></el-option>
                <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                <el-option label="康减系列市代" value="1.1"></el-option>
                <el-option label="康减系列省代" value="2.1"></el-option>
                <el-option label="康减系列CEO" value="3.1"></el-option>

                <el-option label="VIP门店" value="0"></el-option>
                <el-option label="联盟店" value="1"></el-option>
                <el-option label="优秀联盟店" value="1.05"></el-option>
                <el-option label="市代" value="2"></el-option>
                <el-option label="省代" value="3"></el-option>
                <el-option label="CEO" value="4"></el-option>
                <el-option label="总经销商" value="5"></el-option>
                <el-option label="销售公司" value="6"></el-option>

                <el-option label="合伙人" value="2.2"></el-option>
                <el-option label="董事" value="4.2"></el-option>
                <el-option label="经销商" value="4.8"></el-option>
                <el-option label="区域总监" value="5.1"></el-option>
                <el-option label="城市加盟商" value="5.2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select clearable v-model="filters.type" placeholder="请选择">
                <el-option label="发货获得" :value="1"></el-option>
                <el-option label="购买支出" :value="2"></el-option>
                <el-option label="后台变动" :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="getLog()"
              >搜索</el-button>
  

              <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>
  
            </el-form-item>
  
          </el-form>
        </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
        <el-table-column
          prop="username"
          label="昵称"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="手机号"
        >
        </el-table-column>

        <el-table-column
          :formatter="formatterRoleType"
          prop="roleType"
          label="代理等级"
        >
        </el-table-column>

        <el-table-column
          prop="scorePrice"
          label="金额"
        >
        </el-table-column>

        <el-table-column
          :formatter="formatterInfoType"
          prop="infoType"
          label="状态"
        >
        </el-table-column>

          <el-table-column
            prop="createTime"
            label="时间"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "userInData",
  created() {},
  data() {
    return {
      totalMoney: 0,
      userList:[],
      subListVisible: false,
      listLoading: false,
      picList: [],
      askRoleType: null,
      filters: {
        userId: null,
        startTime: null,
        endTime: null,
        userKeyword: null,
        userType: null,
        type: null,
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight: null,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.getLog()

  },
  methods: {
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/send_score_history_list_excel?token=" +
        localStorage.getItem("api_token");
      if(that.filters.userType){
        url = url + "&userType=" + that.filters.userType
      }
      if(that.filters.type){
        url = url + "&type=" + parseInt(that.filters.type)
      }
      if (that.filters.userKeyword) {
        url = url + "&userKeyword=" + that.filters.userKeyword;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime() ;
      }
      if(that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime() ;
      }
      top.location.href = url;
    },
    formatterInfoType(row, column){
      var word = "--";
      if(row.infoType == 1){
        word = "发货获得";
      }else if(row.infoType == 2){
        word = "购买支出";
      }else if(row.infoType == 3){
        word = "后台变动";
      }
      return word;
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.roleType == -1) {
        word = "无";
      } else if (row.roleType == -0.5) {
        word = "康减系列vip会员";
      } else if (row.roleType == -0.4) {
        word = "康减系列高级会员";
      } else if (row.roleType == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.roleType == 0) {
        word = "VIP门店";
      } else if (row.roleType == 1) {
        word = "联盟店";
      } else if (row.roleType == 2) {
        word = "市代";
      } else if (row.roleType == 3) {
        word = "省代";
      } else if (row.roleType == 4) {
        word = "CEO";
      } else if (row.roleType == 1.1) {
        word = "康减系列市代";
      } else if (row.roleType == 2.1) {
        word = "康减系列省代";
      } else if (row.roleType == 3.1) {
        word = "康减系列CEO";
      } else if (row.roleType == 1.05) {
        word = "优秀联盟店";
      } else if (row.roleType == 5) {
        word = "总经销商";
      } else if (row.roleType == 6) {
        word = "销售公司";
      } else if (row.roleType == 2.2) {
        word =  "合伙人";
      } else if (row.roleType == 4.2) {
        word =  "董事";
      } else if (row.roleType == 5.1) {
        word =  "区域总监";
      } else if (row.roleType == 5.2) {
        word =  "城市加盟商";
      } else if (row.roleType == 4.8) {
        word =  "经销商";
      }
      return word;
    },
    getLog(){
      let that = this;
      that.listLoading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if(that.filters.startTime){
        para.startTime = that.filters.startTime.getTime()
      }
      if(that.filters.endTime){
        para.endTime = that.filters.endTime.getTime()
      }
      if(that.filters.userType){
        para.userType = that.filters.userType
      }
      if(that.filters.type){
        para.type = parseInt(that.filters.type)
      }
      if(that.filters.userKeyword){
        para.userKeyword = that.filters.userKeyword
      }
      API.send_score_history_list(para)
        .then(
          function(result) {
            if (result && parseInt(result.key) === 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                for(var i = 0;i<result.result.list.length;i++){
                  result.result.list[i].createTime = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].createTime)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                }
                that.tableData = result.result.list;
              } else {
                that.tableData = [];
              }
              that.listLoading = false
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    getExportUrl(url){
      window.open(url,'_blank')
    },
    formatterStatus(row, column) {
      if (row.status == 1) {
        return "运行中";
      } else if (row.status == 2) {
        return "可下载";
      } else if (row.status == 3) {
        return "运行失败";
      }
    },
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      if (!this.filters.endTime || this.filters.endTime == null || !this.filters.startTime || this.filters.startTime == null || !this.filters.userId || this.filters.userId == null)
      {
        this.$message.error({
            showClose: true,
            message: "请检查下时间或者总经销商是否都已经选择好",
            duration: 2000
          });
      } else
      {
        let that = this;
        that.subListVisible = true;
        this.page_size = 10;
        this.page_num = 1;
        this.searchDetail();
      }

    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.startTime) {
        para.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        para.endTime = that.filters.endTime.getTime();
      }
      that.detailListLoading = true;
      API.order_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num = result.result.count;
            that.total_page = result.result.allPageNumber;


              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableDetailData = result.result.list;
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOutUserDistrict(){
      var that = this;
      var url =
        "/manager/user/pc/app_user_District_balance_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.userId) {
        url = url + "&userId=" + that.filters.userId;
      // } else
      // {
      //   that.$message.error({
      //       showClose: true,
      //       message: "请先选择经销商",
      //       duration: 2000
      //     });
      //   return;
      }
      top.location.href = url;
    },
    handleSearch() {
      this.search();
    },

    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token")
      };
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }

      if (that.filters.userId != null) {
        params.userId = that.filters.userId;
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先总经销商",
            duration: 2000
          });
        return;
      }
      that.listLoading = true;
      API.send_head_num(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableData = result.result.list;
                that.totalMoney = result.result.map.totalM;
              } else {
                that.tableData = [];
              }
              console.info(that.tableData)
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getLog(this.askRoleType);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/capital/userScoreHistory.vue